import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const location = useLocation();

  const handleAnchorClick = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = `/#${id}`;
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-foreground-900 rounded-t-[2.5rem] mt-8 mx-3 md:mx-5 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <span className="absolute bottom-0 left-0 text-[12rem] md:text-[16rem] font-heading font-bold text-foreground-800/8 leading-none whitespace-nowrap select-none">
          CSSBUYSPREADSHEET
        </span>
      </div>

      <div className="relative z-10 px-8 md:px-12 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap">
                CSSBuy<span className="text-primary-400">Spreadsheet</span>
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
                O guia mais completo de spreadsheets CSSBuy. Atualizado diariamente com os melhores produtos da China.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Navegação</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Início', href: '/', isAnchor: false },
                  { label: 'Categorias', href: '#categorias', isAnchor: true, anchorId: 'categorias' },
                  { label: 'Guia', href: '#guia', isAnchor: true, anchorId: 'guia' },
                  { label: 'Blog', href: '/artigo-cssbuyspreadsheet-guia-completo-2026', isAnchor: false },
                ].map((item) => (
                  <li key={item.label}>
                    {item.isAnchor ? (
                      <a
                        href={item.href}
                        onClick={handleAnchorClick(item.anchorId!)}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Links Úteis</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'CSSBuy Sheet', href: mainSiteUrl },
                  { label: 'CSSBuy Oficial', href: 'https://cssbuy.com' },
                  { label: 'Guia de Compras', href: '/artigo-cssbuyspreadsheet-guia-completo-2026' },
                ].map((item) => (
                  <li key={item.label}>
                    {item.href.startsWith('http') ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Acessar</h4>
              <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
                Acesse o CSSBuy Spreadsheet atualizado e encontre os melhores produtos.
              </p>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap group"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 CSSBuySpreadsheet.watch — Todos os direitos reservados.
            </p>
            <p className="text-xs text-foreground-600">
              Guia independente. Não afiliado oficialmente à CSSBuy.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}